<template>
  <div class="container-fluid p-0">
    <PageTitle
      :title="$t('coralSol.localidade')"
      :titleAdd="$t('coralSol.addOcorrencia')"
      :isAdd="true"
      :hasExportCSV="true"
      @onExportCSV="exportCSV"
    />
    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
            <CoralsolLocalidadeTable @orderBy="orderBy" @search="search" :items="items"/>
          </div>
        </div>
      </div>
    </div>
    <!-- /tabela -->
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import CoralsolLocalidadeTable from './CoralsolLocalidadeTable.vue'

export default {
  name: 'CoralsolLocalidade',
  components: { CoralsolLocalidadeTable, PageTitle },
  data () {
    return {
      items: [],
      dataOrderBy: {}
    }
  },
  methods: {
    async exportCSV () {
      this.$store.dispatch('showPreload')

      const params = {
        ...this.$store.state.formSearch,
        Page: this.$store.state.currentPage,
        PageSize: 9999
      }

      try {
        const response = await axios.get('/CoralSolLocality/getlistforexport', { params })

        const data = response.data.items

        if (!data || !data.length) {
          this.$toasted.global.defaultError({ msg: 'Nenhum dado encontrado para exportação.' })
          return
        }

        const headers = [
          'ID',
          'Nome',
          'Data',
          'Unidade de Conservação',
          'Colaborador',
          'Referência Geográfica',
          'Coordenadas'
        ].join(';')

        const rows = data.map(item => {
          return [
            item.locality_id || '',
            item.name || '',
            item.date || '',
            item.conservation_unit || '',
            item.surname || '',
            item.referencia_geografica || '',
            item.coords_local || ''
          ].map(value =>
            typeof value === 'string'
              ? `"${value.replace(/"/g, '""')}"`
              : value != null ? value : ''
          ).join(';')
        })

        const csv = `${headers}\n${rows.join('\n')}`

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'localidades_export.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toasted.global.defaultSuccess({ msg: 'Exportação concluída!' })
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao exportar os dados.' })
        console.error('Erro exportCSV:', error)
      } finally {
        this.$store.dispatch('hidePreload')
      }
    },
    clear () {
      this.$store.commit('clearFormSearch')
    },
    orderBy (dataOrderBy) {
      this.$store.state.dataOrderBy = dataOrderBy
      this.search()
    },
    setFormOrderBy () {
      this.$store.state.formSearch.OrderByIDAcs = this.$store.state.dataOrderBy.OrderByIDAcs
      this.$store.state.formSearch.OrderByIDDesc = this.$store.state.dataOrderBy.OrderByIDDesc
      this.$store.state.formSearch.OrderByNameAcs = this.$store.state.dataOrderBy.OrderByNameAcs
      this.$store.state.formSearch.OrderByNameDesc = this.$store.state.dataOrderBy.OrderByNameDesc
      this.$store.state.formSearch.OrderByLocalCoordsAcs = this.$store.state.dataOrderBy.OrderByLocalCoordsAcs
      this.$store.state.formSearch.OrderByLocalCoordsDesc = this.$store.state.dataOrderBy.OrderByLocalCoordsDesc
      this.$store.state.formSearch.OrderByDateAcs = this.$store.state.dataOrderBy.OrderByDateAcs
      this.$store.state.formSearch.OrderByDateDesc = this.$store.state.dataOrderBy.OrderByDateDesc
      this.$store.state.formSearch.OrderByConservationUnitAcs = this.$store.state.dataOrderBy.OrderByConservationUnitAcs
      this.$store.state.formSearch.OrderByConservationUnitDesc = this.$store.state.dataOrderBy.OrderByConservationUnitDesc
    },
    async search () {
      this.$store.dispatch('showPreload')

      this.setFormOrderBy()
      const params = this.$store.state.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      await axios.get('/CoralSolLocality/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    }
  },
  async created () {
    this.$store.state.formSearch.pending_analysis = true
    await this.search()
  }
}
</script>
